/* ============================================================
   KISHI KAISEI — plafond de quantité sur le stock réel
   ------------------------------------------------------------
   Empêche de mettre au panier plus d'exemplaires qu'il n'en
   existe en stock, sur la fiche produit comme dans le panier.

   Le stock n'est jamais affiché en permanence. Une phrase brève
   « Maximum 3 exemplaires » apparaît uniquement quand le client
   tente de dépasser, puis disparaît.

   Limite connue : une variante dont le suivi d'inventaire est
   désactivé dans Shopify est réputée en stock illimité. Aucun
   plafond n'est calculable pour elle, ici ou ailleurs.
   ============================================================ */
(function () {
  'use strict';

  var NOTE_MS = 4000; /* durée d'affichage de la phrase */

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var stockByVariant = null; /* { id de variante : stock, ou null si non suivi } */
  var qtyInCart = {};        /* { id de variante : quantité déjà au panier } */
  var bound = false;

  function stockOf(id) {
    if (!stockByVariant) return null;
    var v = stockByVariant[String(id)];
    return (v === null || v === undefined) ? null : v;
  }

  /* Ce qu'il reste à ajouter : le stock moins ce qui est déjà au panier */
  function remainingFor(id) {
    var stock = stockOf(id);
    if (stock === null) return null;
    return Math.max(0, stock - (qtyInCart[String(id)] || 0));
  }

  /* Le chiffre annoncé est toujours le stock total, pas le reliquat */
  function maxLabel(stock) {
    return 'Maximum ' + stock + ' exemplaire' + (stock > 1 ? 's' : '');
  }

  function flashNote(el, text) {
    if (!el || !text) return;
    el.textContent = text;
    el.hidden = false;
    if (el.kkHide) clearTimeout(el.kkHide);
    if (el.kkClear) clearTimeout(el.kkClear);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    el.kkHide = setTimeout(function () {
      el.classList.remove('is-visible');
      el.kkClear = setTimeout(function () { el.hidden = true; el.textContent = ''; }, 300);
    }, NOTE_MS);
  }

  function syncCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var counts = {};
        (cart.items || []).forEach(function (item) {
          var key = String(item.variant_id);
          counts[key] = (counts[key] || 0) + item.quantity;
        });
        qtyInCart = counts;
      })
      .catch(function () { /* on garde le plafond posé par Liquid */ });
  }

  /* ---------- Fiche produit ---------- */

  function parts() {
    var form = $('.product-form');
    if (!form) return null;
    var input = $('[data-product-qty]', form);
    return {
      idInput: $('[data-variant-id]', form),
      input: input,
      plus: input ? $('button[data-step="+"]', input.parentNode) : null,
      addBtn: $('[data-add-to-cart]', form),
      note: $('[data-stock-note]')
    };
  }

  /* On ne désactive le bouton que s'il ne l'était pas déjà, et on ne
     réactive que ce qu'on a désactivé : l'état « Épuisé » du thème
     ne doit jamais être levé par nous. */
  function blockAdd(btn) {
    if (!btn || btn.disabled) return false;
    btn.disabled = true;
    btn.dataset.kkStockBlock = '1';
    return true;
  }

  function releaseAdd(btn) {
    if (!btn || btn.dataset.kkStockBlock !== '1') return;
    btn.disabled = false;
    delete btn.dataset.kkStockBlock;
  }

  function markPlus(p, left) {
    if (!p.plus || !p.input) return;
    if (left === null) { p.plus.classList.remove('is-maxed'); return; }
    var val = parseInt(p.input.value, 10) || 1;
    p.plus.classList.toggle('is-maxed', val >= left);
  }

  function applyProduct() {
    var p = parts();
    if (!p || !p.idInput || !stockByVariant) return;

    releaseAdd(p.addBtn);

    var id = p.idInput.value;
    var stock = stockOf(id);
    var left = remainingFor(id);
    var min = p.input ? (parseInt(p.input.min, 10) || 1) : 1;

    /* Stock non suivi : aucune limite connue, on ne touche à rien */
    if (stock === null) {
      if (p.input) p.input.removeAttribute('max');
      if (p.plus) p.plus.classList.remove('is-maxed');
      return;
    }

    if (p.input) {
      p.input.max = left > 0 ? left : min;
      var val = parseInt(p.input.value, 10) || min;
      if (left > 0 && val > left) p.input.value = left;
      if (left <= 0) p.input.value = min;
    }

    /* Tout le stock est déjà au panier : le bouton se désactive, la
       phrase explique pourquoi puis s'efface. */
    if (left <= 0 && stock > 0) {
      if (blockAdd(p.addBtn)) flashNote(p.note, maxLabel(stock));
    }

    markPlus(p, left);
  }

  function initProduct() {
    var p = parts();
    if (!p || !p.input) return;

    /* Saisie au clavier : le thème rend le formulaire en novalidate,
       donc l'attribut max ne bloque rien. On borne à la sortie du champ. */
    p.input.addEventListener('change', function () {
      var min = parseInt(p.input.min, 10) || 1;
      var id = p.idInput ? p.idInput.value : null;
      var left = id ? remainingFor(id) : null;
      var val = parseInt(p.input.value, 10);
      if (isNaN(val) || val < min) val = min;
      if (left !== null && left > 0 && val > left) {
        val = left;
        flashNote(p.note, maxLabel(stockOf(id)));
      }
      p.input.value = val;
      markPlus(p, left);
    });

    /* Le thème a déjà borné la valeur quand on arrive ici : si elle n'a
       pas bougé, c'est que le client a tapé contre le plafond. */
    p.input.parentNode.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-step="+"]');
      if (!btn) return;
      var id = p.idInput ? p.idInput.value : null;
      var left = id ? remainingFor(id) : null;
      if (left === null) return;
      var val = parseInt(p.input.value, 10) || 1;
      if (val >= left) flashNote(p.note, maxLabel(stockOf(id)));
    });

    /* Changement de variante : on repasse après le script du thème */
    $$('[data-variant-select]').forEach(function (sel) {
      sel.addEventListener('change', function () { setTimeout(applyProduct, 0); });
    });
  }

  /* ---------- Panier (page et tiroir) ---------- */

  function lineNote(el) {
    var line = el.closest('.cartline');
    return line ? $('[data-line-note]', line) : null;
  }

  function initCartLines() {
    if (bound) return;
    bound = true;

    /* Clic sur + alors que la ligne est au plafond : on arrête l'événement
       avant le script du thème, sinon il rechargerait la page pour rien. */
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-qty-plus]') : null;
      if (!btn) return;
      var row = btn.parentNode;
      var input = $('[data-qty-input]', row);
      if (!input || !input.dataset.stockMax) return;

      var max = parseInt(input.dataset.stockMax, 10);
      var val = parseInt(input.value, 10) || 0;
      if (val >= max) {
        e.preventDefault();
        e.stopPropagation();
        flashNote(lineNote(btn), maxLabel(max));
      }
    }, true);

    /* Borne la saisie avant que le script du thème ne lise la valeur */
    document.addEventListener('change', function (e) {
      var input = e.target && e.target.closest ? e.target.closest('[data-qty-input]') : null;
      if (!input) return;

      var max = parseInt(input.dataset.stockMax, 10);
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < 0) val = 0;

      if (!isNaN(max) && val > max) {
        val = max;
        flashNote(lineNote(input), maxLabel(max));
      }

      input.value = val;
    }, true);
  }

  /* ---------- Resynchronisation ---------- */

  /* Le compteur du panier est mis à jour par le thème après chaque
     ajout ou modification : c'est notre signal pour recalculer. */
  function watchCart() {
    var counter = $('[data-cart-count]');
    if (!counter || !('MutationObserver' in window)) return;
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(function () { syncCart().then(applyProduct); }, 150);
    }).observe(counter, { childList: true, characterData: true, subtree: true });
  }

  function init() {
    initCartLines();

    var data = $('[data-variant-stock]');
    if (!data) return;
    try { stockByVariant = JSON.parse(data.textContent); } catch (e) { return; }

    initProduct();
    watchCart();
    syncCart().then(applyProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Ré-initialise après une modification dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', init);

  /* Retour arrière du navigateur : le panier a pu changer entre-temps */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && stockByVariant) syncCart().then(applyProduct);
  });
})();
